import type { PropsWithChildren } from 'react';

import { twMerge } from 'tailwind-merge';

export function ActionButtonContainer({
  children,
  className,
  disabled,
}: PropsWithChildren<{ className?: string; disabled?: boolean }>) {
  return (
    <div
      className={twMerge(
        'flex h-11 w-7 shrink-0 grow-0 items-center justify-center gap-x-1 border-b pt-2 transition-all delay-300',
        disabled ? 'border-c-border-muted' : 'border-c-border',
        className
      )}
    >
      {children}
    </div>
  );
}
